"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.learningComponent = exports.LearningComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var dictionary_1 = require("Views/Partials/Components/TableCore/dictionary");
var LearningComponent_1 = require("./components/LearningComponent");
var LearningDataService_1 = require("./services/LearningDataService");
var LearningComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LearningComponent, _super);
    function LearningComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.learning-component-table';
        return _this;
    }
    LearningComponent.prototype.OnInit = function () {
        var _this = this;
        this.el.forEach(function (el, index) {
            _this.renderLearningComponent(el, index);
        });
    };
    LearningComponent.prototype.renderLearningComponent = function (el, _index) {
        var dictionary = (0, app_1.transformDictionary)(dictionary_1.tableDictionary, app_1.AttrService.data(el, 'dictionary'));
        var searchUrl = el.getAttribute('data-learning-search-url');
        var searchParams = {
            query: el.getAttribute('data-learning-search-query'),
            language: el.getAttribute('data-language'),
        };
        var tableCaption = el.dataset['tableCaption'];
        var tileStatusExpanded = app_1.AttrService.data(el, 'tile-status-expanded');
        (0, LearningComponent_1.RenderLearningComponent)({
            dataService: new LearningDataService_1.LearningDataService(searchUrl, searchParams),
            dictionary: dictionary,
            tableCaption: tableCaption,
            tileStatusExpanded: tileStatusExpanded === 'True',
        }, el);
    };
    return LearningComponent;
}(app_1.Component));
exports.LearningComponent = LearningComponent;
exports.learningComponent = new LearningComponent();
